import http from '@utils/http'

/*
* 获取AI类型
**/
export function getAiType(data): Promise<any> {
    return http.post('/ai/aiType', data || {})
}
/*
* 获取AI类型
**/
export function chatMsgStream(data): Promise<any> {
    return http.post('/ai/chatMsgStream', data || {})
}
/*
* 获取微信用户信息
**/
export function wxLogin(data): Promise<any> {
    return http.get('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6f5057302da09451&redirect_uri=http%3A%2F%2Faoacuatwap.lenovoconnect.com%2Fai%2Fgzh%2Fcallback&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect', data || {})
}

/*
* 获取openid
**/
export function getOpenId(data): Promise<any> {
    return http.post('/ai/gzh/callback', data || {})
}

/*
* 获取AI提问-记录使用记录
**/
export function getAiUseLog(data): Promise<any> {
    return http.post('/ai/aiUseLog', data || {})
}

/*
* AI提问问题-前10
**/
export function getChatMsgLog(data): Promise<any> {
    return http.post('/ai/chatMsgLog', data || {})
}
/*
* AI提问 -使用记录详情
**/
export function getMsgLog(data): Promise<any> {
    return http.post('/ai/getMsgLog', data || {})
}
/*
* AI提问 -使用记录清空
**/
export function delLog(data): Promise<any> {
    return http.post('/ai/delLog', data || {})
}


